import React, { useState, useEffect, useContext } from 'react';
import style from '../components/common/style';
import { TableComp } from '../components/common/table';
import { listSpecialDealsList, colSpecialDealsList } from '../context/data';
import { MiniHeader } from '../components/common/customComponent';
import { options } from '../context/data';
import ReactPaginate from 'react-paginate';
import { useHistory } from 'react-router-dom';
// import style from '../../components/common/style';
import styles from '../components/common/style';
import LangContext from '../context/languageContext';
import Loading from '../components/common/Loading';
import { customInputLabel } from '../components/createAppVersionComponent/createAppVersionComponent';
import { ArrowUpIcon, ArrowDownIcon } from '@chakra-ui/icons';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
  Tr,
  Th,
  Td,
  Flex,
  Text,
  Table,
  Tbody,
  Select,
  Thead,
  Spacer,
  Button,
  useToast,
  Divider,
  Tooltip,
} from '@chakra-ui/react';
// import { TableComp } from '../components/common/table';
import { MdImportExport } from 'react-icons/md';
import ApiManager from '../config/apiManager';

const SpecialDealsList = () => {
  let tempArray = [];

  let toast = useToast();
  let history = useHistory();
  const [page, setPage] = useState(1);
  const [error, setError] = useState(null);
  const [value, setValue] = useState('10');
  const [data, setData] = React.useState([]);
  let apiManager = ApiManager.getInstance();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = React.useState('');
  const [paginate, setpaginate] = React.useState();
  const [pageChange, setPageChange] = useState('');
  const { currentLangData } = useContext(LangContext);
  const [valueSearch, setValueSearch] = React.useState();
  const [selectvalue, setSelectvalue] = React.useState(10);
  const [currentPage, setCurrentPage] = React.useState(0);

  React.useEffect(() => {
    getAllCategory(page, value);
  }, []);

  // Utility functions /
  const handlePageClick = ({ selected: selectedPage }) => {
    console.log('next and previous', loading);
    setCurrentPage(selectedPage);
    getAllCategory(selectedPage + 1, value);
    console.log('clicked', selectedPage + 1);
  };

  const handleOnChange = (evt, key) => {
    const ev = evt.target.value;
    console.log('event', ev);
    setValue(ev);
    getAllCategory(page, ev);
  };

  let totalDatalength = paginate?.totalDocs;
  const PER_PAGE = selectvalue;
  const offset = currentPage * PER_PAGE;
  let pageCount = paginate?.totalPages;
  const pageCeilingCount = Math.ceil().paginate?.totalPages;
  console.log(pageCeilingCount, 'PAGE COUNT', pageCount);

  useEffect(() => {}, [page]);
  useEffect(() => {}, [value]);

  const navigateToEditPage = editData => {
    console.log('editData=>', editData);
    history.push({
      pathname: '/CreateSpecialDeal',
      state: { data: editData, useEditApi: true },
    });
  };

  // Api implementation //

  const deleteRecord = data => {
    console.log('deleteRecord', data);
    let body = {
      id: data?._id,
    };
    apiManager
      .post('deleteOneTimeDeal', body)
      .then(res => {
        console.log('response=>', res);
        if (res.message === 8306) {
          setSuccess('Deleted');
          toast({
            title: success,
            status: 'success',
            duration: 2000,
            // isClosable: true,
            description: `Successfully Deleted record!`,
          });
          getAllCategory(1, value);
        } else {
          setError('Something went wrong');
          toast({
            title: error,
            duration: 2000,
            status: 'error',
            // isClosable: true,
            description: `Failed! Please try agian later!`,
          });
          getAllCategory(1, value);
        }
      })
      .catch(error => {
        console.log('error', error);
      });
  };

  const getAllCategory = (page, value) => {
    setLoading(true);
    let tempArray = [];
    console.log('page=>', page);
    let body = {
      page: page,
      // nextPage: 3,
      numRecords: value,
    };
    apiManager
      .get('getAllOneTimeDeals', body)
      .then(res => {
        console.log('getAllOneTimeDeals=>RES', res);
        if (res.message === 8308) {
          console.log('Get getAllOneTimeDeals', res);
          pageCount = res.deals.totalDocs;
          res.deals.docs.map((value, index) => {
            console.log('valuesssss', value);
            tempArray.push(value);
          });
          setpaginate(res.deals);
          setData(tempArray);
          setLoading(false);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log('error', error);
      });
  };

  const handleOnSearch = (evt, key) => {
    const ev = evt.target.value;
    setValueSearch(ev);
    searchItems(ev, value, 1);
  };

  const searchItems = (value, limit, page) => {
    console.log('searchItems', value, limit, page);
    setLoading(true);
    const body = {
      searchPhrase: value,
      numRecords: limit,
      page: page,
    };
    console.log('body', body);
    apiManager
      .post('searchOneTimeDeal', body)
      .then(res => {
        console.log('res=>', res.message);
        if (res.message === 8310) {
          res?.record?.docs.map((value, index) => {
            tempArray.push(value);
          });
          setData(tempArray);
          setpaginate(res?.record);
          setLoading(false);
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoading(false);
      });
  };

  const convertingDate = date => {
    let newDate = new Date(date);
    return newDate.toLocaleString();
  };

  const changStatus = v => {
    console.log(v);
    if (v === true) {
      return 'Active';
    } else if (v === false) {
      return 'Inactive';
    }
  };

  const changeSpecificHour = value => {
    console.log('value=>', value);
    if (value === 0) {
      return 'All User';
    } else if (value === 1) {
      return 'New User';
    }
  };

  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Special Deals List',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path2: 'One Time Deals Management',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main} padding={5}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreateSpecialDeal')}
            >
              Create
            </Button>
          </Flex>

          <Flex {...style.optionFlex}>
            <Flex {...style.showentries} alignItems={'center'} fontSize={'sm'}>
              <Text>{currentLangData?.app?.show}</Text>
              <Select
                {...style.select}
                onChange={e => handleOnChange(e, 'numrecords')}
              >
                {options.map(option => (
                  <option value={option.value}>{option.label}</option>
                ))}
              </Select>
              <Text>{currentLangData?.app?.entries}</Text>
            </Flex>
            <Spacer />
            <Flex alignItems={'center'} {...style.showentries}>
              <Text paddingX={'5px'}>{currentLangData?.app?.search}: </Text>
              {customInputLabel({
                size: 'sm',
                onChange: e => handleOnSearch(e),
              })}
            </Flex>
          </Flex>

          <Table {...styles.table} padding={'1%'}>
            <Thead {...styles.thead}>
              <Tr>
                <Th {...styles.th}>Start Date</Th>
                <Th {...styles.th}>End Date</Th>
                <Th {...styles.th}>Name</Th>
                <Th {...styles.th}>Target User</Th>
                <Th {...styles.th}>Status</Th>
                <Th {...styles.th}>Actions</Th>
              </Tr>
            </Thead>
            <Tbody {...styles.tbody}>
              {data?.length > 0 ? (
                !loading ? (
                  data &&
                  data?.map((value, index) => {
                    let stat = changStatus(value.status);
                    if (index >= 0) {
                      return (
                        <>
                          <Tr key={index} {...styles.tr}>
                            <Td>{convertingDate(value?.startDate)}</Td>

                            <Td
                              flex={1}
                              justifyContent={'center'}
                              alignItems={'center'}
                            >
                              {convertingDate(value?.endDate)}
                            </Td>

                            <Td
                              flex={1}
                              justifyContent={'center'}
                              alignItems={'center'}
                            >
                              {value?.name}
                            </Td>

                            <Td
                              flex={1}
                              justifyContent={'center'}
                              alignItems={'center'}
                            >
                              {changeSpecificHour(value?.targetUser)}
                            </Td>

                            <Td
                              flex={1}
                              justifyContent={'center'}
                              alignItems={'center'}
                            >
                              {stat}
                            </Td>

                            <Td
                              width={'20%'}
                              flexDirection={'row'}
                              alignItems={'center'}
                              justifyContent={'flex-end'}
                            >
                              <Tooltip label={currentLangData?.app?.edit}>
                                <Button
                                  {...style.editbtn}
                                  leftIcon={<EditIcon />}
                                  onClick={() => navigateToEditPage(value)}
                                ></Button>
                              </Tooltip>
                              <Tooltip
                                label={currentLangData?.app?.delete}
                                bg={'red'}
                              >
                                <Button
                                  {...style.Delbtn}
                                  leftIcon={<DeleteIcon />}
                                  onClick={() => deleteRecord(value)}
                                ></Button>
                              </Tooltip>
                            </Td>
                          </Tr>
                        </>
                      );
                    } else {
                      return (
                        <Tr height={'40vh'}>
                          <Td></Td>
                          <Td>
                            <Text>NO DATA AVAILABLE</Text>
                          </Td>
                          <Td></Td>
                        </Tr>
                      );
                    }
                  })
                ) : (
                  <Tr>
                    {/* <Td></Td> */}
                    <Td></Td>
                    <Td></Td>
                    <Td paddingY={'15vh'}>
                      <Flex
                        style={{
                          w: '100%',
                          h: '100%',
                          d: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          top: '0',
                          left: '0',
                        }}
                      >
                        <Loading />
                      </Flex>
                    </Td>
                    <Td></Td>
                    <Td></Td>
                  </Tr>
                )
              ) : (
                <Tr>
                  <Td paddingY={'15vh'}>
                    <Flex {...style.elseflex}>
                      <Text fontSize={'xl'}>Oops! Data bucket is Empty</Text>
                    </Flex>
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
          <Spacer />
          <Divider orientation="horizontal" marginTop={5} marginBottom={2} />

          <Flex {...style.paginatecontainer} justifyContent={'space-between'}>
            <Text>
              Showing {data.length} to {PER_PAGE} of {totalDatalength} entries
            </Text>
            <ReactPaginate
              nextLabel={'Next'}
              pageCount={pageCount}
              previousLabel={'Previous'}
              activeClassName={'active'}
              nextClassName={'page-item'}
              pageClassName={'page-item'}
              nextLinkClassName={'page-link'}
              pageLinkClassName={'page-link'}
              previousClassName={'page-item'}
              containerClassName={'pagination'}
              onPageChange={handlePageClick}
              previousLinkClassName={'page-link'}
            />
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};
export default SpecialDealsList;
